"use memo"

import {
  AgxDivider,
  AgxSpacer,
  AgxTypography,
} from '@urbanx/agx.ui-components2'
import { TaskModalPageProps } from 'pages/allTasks/TaskModal/TaskModalPageProps'
import React from 'react'
import TaskModalStepToggle from '../TaskModalStepToggle'

const QldAgreementDetails = (props: TaskModalPageProps) => {
  const { task, taskNumber } = props
  return (
    <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
      <AgxTypography
        size="large"
        type="label"
        id="step1title"
        color="var(--text-primary)"
      >
        {`Step ${taskNumber} : Agreement Details`}
      </AgxTypography>
      <AgxSpacer direction="vertical" gap="spacing-xl" fill>
        {task.taskSteps?.map((step, index) => {
          return (
            <React.Fragment key={`step-${step.name}`}>
              <TaskModalStepToggle {...props} step={step} />
              {index < (task.taskSteps?.length ?? 0) - 1 && (
                <AgxDivider variant="horizontal" />
              )}
            </React.Fragment>
          )
        })}
      </AgxSpacer>
    </AgxSpacer>
  )
}

export default QldAgreementDetails
